import createReducer from '../../utils/createReducer';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  // timeZones: [],
  userSettings: null,
  requesting: false,
  error: null,
  userIsAPublish: false,
  isADraft: false,
};

const user = createReducer(initialState, {
  [actionTypes.USER_SETTINGS_REQUEST](state) {
    return { ...state, requesting: true, error: null };
  },
  [actionTypes.SET_IS_A_DRAFT](state, { payload }) {
    return { ...state, isADraft: payload };
  },
  [actionTypes.USER_SETTINGS_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  [actionTypes.USER_SETTINGS_STORE](state, { payload }) {
    return {
      ...state,
      // timeZones: [...payload.timeZones],
      userSettings: payload.userSettings,
      requesting: false,
      error: null,
    };
  },
  [actionTypes.SET_USER_IS_A_PUBLISH](state, { payload }) {
    return {
      ...state,
      userIsAPublish: payload,
    };
  },
});

export default user;

export const getUserSettings = (state) => state.user.userSettings;
export const getUserIsAPublish = (state) => state.user.userIsAPublish;
export const getUserIsADraft = (state) => state.user.isADraft;
// export const getTimeZones = state => state.user.timeZones;
